/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DepartmentCreateRequest,
  DepartmentListResponse,
  DepartmentResponse,
  EmployeeCreateRequest,
  EmployeeDetailResponse,
  EmployeeListResponse,
  EmployeeOverviewSummary,
  EmployeeSkillResponse,
  GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetParams,
  GetHrTableDataV1HrTablesTableNameDataGetParams,
  GetHrTablesListV1HrTablesGetParams,
  GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetParams,
  GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetParams,
  HRTablesListResponse,
  HTTPValidationError,
  ListDepartmentsV1HrDepartmentsGetParams,
  ListEmployeesV1HrEmployeesGetParams,
  ListSkillsV1HrSkillsGetParams,
  PerformanceDevelopmentSummary,
  SkillsCompetenciesSummary,
  SrcApiSchemasHrSkillListResponse
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * Get paginated list of departments with optional filtering.

Requires: hr:read permission
 * @summary List Departments
 */
export const listDepartmentsV1HrDepartmentsGet = (
    params?: ListDepartmentsV1HrDepartmentsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DepartmentListResponse>(
      {url: `/v1/hr/departments`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListDepartmentsV1HrDepartmentsGetQueryKey = (params?: ListDepartmentsV1HrDepartmentsGetParams,) => {
    return [
    `/v1/hr/departments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListDepartmentsV1HrDepartmentsGetQueryOptions = <TData = Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError = HTTPValidationError>(params?: ListDepartmentsV1HrDepartmentsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDepartmentsV1HrDepartmentsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>> = ({ signal }) => listDepartmentsV1HrDepartmentsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListDepartmentsV1HrDepartmentsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>>
export type ListDepartmentsV1HrDepartmentsGetQueryError = HTTPValidationError


export function useListDepartmentsV1HrDepartmentsGet<TData = Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListDepartmentsV1HrDepartmentsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>,
          TError,
          Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListDepartmentsV1HrDepartmentsGet<TData = Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError = HTTPValidationError>(
 params?: ListDepartmentsV1HrDepartmentsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>,
          TError,
          Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListDepartmentsV1HrDepartmentsGet<TData = Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError = HTTPValidationError>(
 params?: ListDepartmentsV1HrDepartmentsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Departments
 */

export function useListDepartmentsV1HrDepartmentsGet<TData = Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError = HTTPValidationError>(
 params?: ListDepartmentsV1HrDepartmentsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDepartmentsV1HrDepartmentsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListDepartmentsV1HrDepartmentsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new department.

Requires: hr:write permission
 * @summary Create Department
 */
export const createDepartmentV1HrDepartmentsPost = (
    departmentCreateRequest: DepartmentCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DepartmentResponse>(
      {url: `/v1/hr/departments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: departmentCreateRequest, signal
    },
      );
    }
  


export const getCreateDepartmentV1HrDepartmentsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartmentV1HrDepartmentsPost>>, TError,{data: DepartmentCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDepartmentV1HrDepartmentsPost>>, TError,{data: DepartmentCreateRequest}, TContext> => {

const mutationKey = ['createDepartmentV1HrDepartmentsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDepartmentV1HrDepartmentsPost>>, {data: DepartmentCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createDepartmentV1HrDepartmentsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDepartmentV1HrDepartmentsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createDepartmentV1HrDepartmentsPost>>>
    export type CreateDepartmentV1HrDepartmentsPostMutationBody = DepartmentCreateRequest
    export type CreateDepartmentV1HrDepartmentsPostMutationError = HTTPValidationError

    /**
 * @summary Create Department
 */
export const useCreateDepartmentV1HrDepartmentsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartmentV1HrDepartmentsPost>>, TError,{data: DepartmentCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDepartmentV1HrDepartmentsPost>>,
        TError,
        {data: DepartmentCreateRequest},
        TContext
      > => {

      const mutationOptions = getCreateDepartmentV1HrDepartmentsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get a single department by ID.

Requires: hr:read permission
 * @summary Get Department
 */
export const getDepartmentV1HrDepartmentsDepartmentIdGet = (
    departmentId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DepartmentResponse>(
      {url: `/v1/hr/departments/${departmentId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetDepartmentV1HrDepartmentsDepartmentIdGetQueryKey = (departmentId?: number,) => {
    return [
    `/v1/hr/departments/${departmentId}`
    ] as const;
    }

    
export const getGetDepartmentV1HrDepartmentsDepartmentIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError = HTTPValidationError>(departmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentV1HrDepartmentsDepartmentIdGetQueryKey(departmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>> = ({ signal }) => getDepartmentV1HrDepartmentsDepartmentIdGet(departmentId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(departmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDepartmentV1HrDepartmentsDepartmentIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>>
export type GetDepartmentV1HrDepartmentsDepartmentIdGetQueryError = HTTPValidationError


export function useGetDepartmentV1HrDepartmentsDepartmentIdGet<TData = Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError = HTTPValidationError>(
 departmentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDepartmentV1HrDepartmentsDepartmentIdGet<TData = Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError = HTTPValidationError>(
 departmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDepartmentV1HrDepartmentsDepartmentIdGet<TData = Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError = HTTPValidationError>(
 departmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Department
 */

export function useGetDepartmentV1HrDepartmentsDepartmentIdGet<TData = Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError = HTTPValidationError>(
 departmentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentV1HrDepartmentsDepartmentIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDepartmentV1HrDepartmentsDepartmentIdGetQueryOptions(departmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get paginated list of employees with optional filtering.

Requires: hr:read permission
 * @summary List Employees
 */
export const listEmployeesV1HrEmployeesGet = (
    params?: ListEmployeesV1HrEmployeesGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployeeListResponse>(
      {url: `/v1/hr/employees`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListEmployeesV1HrEmployeesGetQueryKey = (params?: ListEmployeesV1HrEmployeesGetParams,) => {
    return [
    `/v1/hr/employees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListEmployeesV1HrEmployeesGetQueryOptions = <TData = Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError = HTTPValidationError>(params?: ListEmployeesV1HrEmployeesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmployeesV1HrEmployeesGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>> = ({ signal }) => listEmployeesV1HrEmployeesGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListEmployeesV1HrEmployeesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>>
export type ListEmployeesV1HrEmployeesGetQueryError = HTTPValidationError


export function useListEmployeesV1HrEmployeesGet<TData = Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError = HTTPValidationError>(
 params: undefined |  ListEmployeesV1HrEmployeesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>,
          TError,
          Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListEmployeesV1HrEmployeesGet<TData = Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError = HTTPValidationError>(
 params?: ListEmployeesV1HrEmployeesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>,
          TError,
          Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListEmployeesV1HrEmployeesGet<TData = Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError = HTTPValidationError>(
 params?: ListEmployeesV1HrEmployeesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Employees
 */

export function useListEmployeesV1HrEmployeesGet<TData = Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError = HTTPValidationError>(
 params?: ListEmployeesV1HrEmployeesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmployeesV1HrEmployeesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListEmployeesV1HrEmployeesGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new employee.

Requires: hr:write permission
 * @summary Create Employee
 */
export const createEmployeeV1HrEmployeesPost = (
    employeeCreateRequest: EmployeeCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployeeDetailResponse>(
      {url: `/v1/hr/employees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: employeeCreateRequest, signal
    },
      );
    }
  


export const getCreateEmployeeV1HrEmployeesPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeV1HrEmployeesPost>>, TError,{data: EmployeeCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createEmployeeV1HrEmployeesPost>>, TError,{data: EmployeeCreateRequest}, TContext> => {

const mutationKey = ['createEmployeeV1HrEmployeesPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmployeeV1HrEmployeesPost>>, {data: EmployeeCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createEmployeeV1HrEmployeesPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateEmployeeV1HrEmployeesPostMutationResult = NonNullable<Awaited<ReturnType<typeof createEmployeeV1HrEmployeesPost>>>
    export type CreateEmployeeV1HrEmployeesPostMutationBody = EmployeeCreateRequest
    export type CreateEmployeeV1HrEmployeesPostMutationError = HTTPValidationError

    /**
 * @summary Create Employee
 */
export const useCreateEmployeeV1HrEmployeesPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmployeeV1HrEmployeesPost>>, TError,{data: EmployeeCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmployeeV1HrEmployeesPost>>,
        TError,
        {data: EmployeeCreateRequest},
        TContext
      > => {

      const mutationOptions = getCreateEmployeeV1HrEmployeesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get a single employee by ID with related entities.

Requires: hr:read permission
 * @summary Get Employee
 */
export const getEmployeeV1HrEmployeesEmployeeIdGet = (
    employeeId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployeeDetailResponse>(
      {url: `/v1/hr/employees/${employeeId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetEmployeeV1HrEmployeesEmployeeIdGetQueryKey = (employeeId?: number,) => {
    return [
    `/v1/hr/employees/${employeeId}`
    ] as const;
    }

    
export const getGetEmployeeV1HrEmployeesEmployeeIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError = HTTPValidationError>(employeeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeV1HrEmployeesEmployeeIdGetQueryKey(employeeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>> = ({ signal }) => getEmployeeV1HrEmployeesEmployeeIdGet(employeeId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employeeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetEmployeeV1HrEmployeesEmployeeIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>>
export type GetEmployeeV1HrEmployeesEmployeeIdGetQueryError = HTTPValidationError


export function useGetEmployeeV1HrEmployeesEmployeeIdGet<TData = Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError = HTTPValidationError>(
 employeeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployeeV1HrEmployeesEmployeeIdGet<TData = Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError = HTTPValidationError>(
 employeeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployeeV1HrEmployeesEmployeeIdGet<TData = Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError = HTTPValidationError>(
 employeeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Employee
 */

export function useGetEmployeeV1HrEmployeesEmployeeIdGet<TData = Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError = HTTPValidationError>(
 employeeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeV1HrEmployeesEmployeeIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetEmployeeV1HrEmployeesEmployeeIdGetQueryOptions(employeeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get paginated list of skills with optional filtering.

Requires: hr:read permission
 * @summary List Skills
 */
export const listSkillsV1HrSkillsGet = (
    params?: ListSkillsV1HrSkillsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SrcApiSchemasHrSkillListResponse>(
      {url: `/v1/hr/skills`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListSkillsV1HrSkillsGetQueryKey = (params?: ListSkillsV1HrSkillsGetParams,) => {
    return [
    `/v1/hr/skills`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListSkillsV1HrSkillsGetQueryOptions = <TData = Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError = HTTPValidationError>(params?: ListSkillsV1HrSkillsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSkillsV1HrSkillsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>> = ({ signal }) => listSkillsV1HrSkillsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListSkillsV1HrSkillsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>>
export type ListSkillsV1HrSkillsGetQueryError = HTTPValidationError


export function useListSkillsV1HrSkillsGet<TData = Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListSkillsV1HrSkillsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>,
          TError,
          Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListSkillsV1HrSkillsGet<TData = Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError = HTTPValidationError>(
 params?: ListSkillsV1HrSkillsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>,
          TError,
          Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListSkillsV1HrSkillsGet<TData = Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError = HTTPValidationError>(
 params?: ListSkillsV1HrSkillsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Skills
 */

export function useListSkillsV1HrSkillsGet<TData = Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError = HTTPValidationError>(
 params?: ListSkillsV1HrSkillsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSkillsV1HrSkillsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListSkillsV1HrSkillsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get all skills for an employee.

Requires: hr:read permission
 * @summary Get Employee Skills
 */
export const getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet = (
    employeeId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployeeSkillResponse[]>(
      {url: `/v1/hr/employees/${employeeId}/skills`, method: 'GET', signal
    },
      );
    }
  



export const getGetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGetQueryKey = (employeeId?: number,) => {
    return [
    `/v1/hr/employees/${employeeId}/skills`
    ] as const;
    }

    
export const getGetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGetQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError = HTTPValidationError>(employeeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGetQueryKey(employeeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>> = ({ signal }) => getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet(employeeId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(employeeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>>
export type GetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGetQueryError = HTTPValidationError


export function useGetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet<TData = Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError = HTTPValidationError>(
 employeeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet<TData = Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError = HTTPValidationError>(
 employeeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet<TData = Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError = HTTPValidationError>(
 employeeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Employee Skills
 */

export function useGetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet<TData = Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError = HTTPValidationError>(
 employeeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetEmployeeSkillsV1HrEmployeesEmployeeIdSkillsGetQueryOptions(employeeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get employee overview summary for executives.

Provides high-level metrics about employees including:
- Total employee counts by status, type, and location
- Department and position breakdowns
- Average tenure

Requires: hr:read permission
 * @summary Get Employee Overview Summary
 */
export const getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet = (
    params?: GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmployeeOverviewSummary>(
      {url: `/v1/hr/summaries/employee-overview`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetQueryKey = (params?: GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetParams,) => {
    return [
    `/v1/hr/summaries/employee-overview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetQueryOptions = <TData = Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError = HTTPValidationError>(params?: GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>> = ({ signal }) => getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>>
export type GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetQueryError = HTTPValidationError


export function useGetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet<TData = Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError = HTTPValidationError>(
 params: undefined |  GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet<TData = Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError = HTTPValidationError>(
 params?: GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet<TData = Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError = HTTPValidationError>(
 params?: GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Employee Overview Summary
 */

export function useGetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet<TData = Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError = HTTPValidationError>(
 params?: GetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetEmployeeOverviewSummaryV1HrSummariesEmployeeOverviewGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get skills and competencies summary for executives.

Provides insights about organizational skills including:
- Total skills and skill assignments
- Proficiency level distribution
- Skills by category
- Average experience levels

Requires: hr:read permission
 * @summary Get Skills Competencies Summary
 */
export const getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet = (
    params?: GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SkillsCompetenciesSummary>(
      {url: `/v1/hr/summaries/skills-competencies`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetQueryKey = (params?: GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetParams,) => {
    return [
    `/v1/hr/summaries/skills-competencies`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetQueryOptions = <TData = Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError = HTTPValidationError>(params?: GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>> = ({ signal }) => getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>>
export type GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetQueryError = HTTPValidationError


export function useGetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet<TData = Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError = HTTPValidationError>(
 params: undefined |  GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>,
          TError,
          Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet<TData = Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError = HTTPValidationError>(
 params?: GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>,
          TError,
          Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet<TData = Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError = HTTPValidationError>(
 params?: GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Skills Competencies Summary
 */

export function useGetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet<TData = Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError = HTTPValidationError>(
 params?: GetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSkillsCompetenciesSummaryV1HrSummariesSkillsCompetenciesGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get performance and development summary for executives.

Provides insights about employee performance and development including:
- Performance review metrics
- Promotion readiness
- Training completion and ratings
- Goals achievement
- Department-level performance

Requires: hr:read permission
 * @summary Get Performance Development Summary
 */
export const getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet = (
    params?: GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PerformanceDevelopmentSummary>(
      {url: `/v1/hr/summaries/performance-development`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetQueryKey = (params?: GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetParams,) => {
    return [
    `/v1/hr/summaries/performance-development`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetQueryOptions = <TData = Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError = HTTPValidationError>(params?: GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>> = ({ signal }) => getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetQueryResult = NonNullable<Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>>
export type GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetQueryError = HTTPValidationError


export function useGetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet<TData = Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError = HTTPValidationError>(
 params: undefined |  GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet<TData = Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError = HTTPValidationError>(
 params?: GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>,
          TError,
          Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet<TData = Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError = HTTPValidationError>(
 params?: GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Performance Development Summary
 */

export function useGetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet<TData = Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError = HTTPValidationError>(
 params?: GetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPerformanceDevelopmentSummaryV1HrSummariesPerformanceDevelopmentGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get list of all HR tables with metadata.

Provides information about available HR data tables including:
- Table names and descriptions
- Record counts
- API endpoints

Requires: hr:read permission
 * @summary Get Hr Tables List
 */
export const getHrTablesListV1HrTablesGet = (
    params?: GetHrTablesListV1HrTablesGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<HRTablesListResponse>(
      {url: `/v1/hr/tables`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetHrTablesListV1HrTablesGetQueryKey = (params?: GetHrTablesListV1HrTablesGetParams,) => {
    return [
    `/v1/hr/tables`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetHrTablesListV1HrTablesGetQueryOptions = <TData = Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError = HTTPValidationError>(params?: GetHrTablesListV1HrTablesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrTablesListV1HrTablesGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>> = ({ signal }) => getHrTablesListV1HrTablesGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetHrTablesListV1HrTablesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>>
export type GetHrTablesListV1HrTablesGetQueryError = HTTPValidationError


export function useGetHrTablesListV1HrTablesGet<TData = Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError = HTTPValidationError>(
 params: undefined |  GetHrTablesListV1HrTablesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>,
          TError,
          Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetHrTablesListV1HrTablesGet<TData = Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError = HTTPValidationError>(
 params?: GetHrTablesListV1HrTablesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>,
          TError,
          Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetHrTablesListV1HrTablesGet<TData = Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError = HTTPValidationError>(
 params?: GetHrTablesListV1HrTablesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Hr Tables List
 */

export function useGetHrTablesListV1HrTablesGet<TData = Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError = HTTPValidationError>(
 params?: GetHrTablesListV1HrTablesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTablesListV1HrTablesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetHrTablesListV1HrTablesGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get data from a specific HR table.

This endpoint returns the actual data from the specified HR table with pagination support.

Args:
    table_name: Name of the HR table (e.g., 'hr_employees', 'hr_departments')
    customer_id: Customer ID for multi-tenancy
    limit: Maximum number of rows to return (default: 100, max: 1000)
    offset: Number of rows to skip for pagination (default: 0)

Returns:
    JSON object with:
    - data: List of rows from the table
    - total_count: Total number of rows in the table
    - columns: List of column names
    - limit: Applied limit
    - offset: Applied offset

Requires: hr:read permission
 * @summary Get Hr Table Data
 */
export const getHrTableDataV1HrTablesTableNameDataGet = (
    tableName: string,
    params?: GetHrTableDataV1HrTablesTableNameDataGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/hr/tables/${tableName}/data`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetHrTableDataV1HrTablesTableNameDataGetQueryKey = (tableName?: string,
    params?: GetHrTableDataV1HrTablesTableNameDataGetParams,) => {
    return [
    `/v1/hr/tables/${tableName}/data`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetHrTableDataV1HrTablesTableNameDataGetQueryOptions = <TData = Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError = HTTPValidationError>(tableName: string,
    params?: GetHrTableDataV1HrTablesTableNameDataGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHrTableDataV1HrTablesTableNameDataGetQueryKey(tableName,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>> = ({ signal }) => getHrTableDataV1HrTablesTableNameDataGet(tableName,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetHrTableDataV1HrTablesTableNameDataGetQueryResult = NonNullable<Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>>
export type GetHrTableDataV1HrTablesTableNameDataGetQueryError = HTTPValidationError


export function useGetHrTableDataV1HrTablesTableNameDataGet<TData = Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError = HTTPValidationError>(
 tableName: string,
    params: undefined |  GetHrTableDataV1HrTablesTableNameDataGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>,
          TError,
          Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetHrTableDataV1HrTablesTableNameDataGet<TData = Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError = HTTPValidationError>(
 tableName: string,
    params?: GetHrTableDataV1HrTablesTableNameDataGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>,
          TError,
          Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetHrTableDataV1HrTablesTableNameDataGet<TData = Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError = HTTPValidationError>(
 tableName: string,
    params?: GetHrTableDataV1HrTablesTableNameDataGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Hr Table Data
 */

export function useGetHrTableDataV1HrTablesTableNameDataGet<TData = Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError = HTTPValidationError>(
 tableName: string,
    params?: GetHrTableDataV1HrTablesTableNameDataGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHrTableDataV1HrTablesTableNameDataGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetHrTableDataV1HrTablesTableNameDataGetQueryOptions(tableName,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



